import React from 'react';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router';

import './Configuration.scss';
import OrgPermissions from './OrgPermissions';
import OrgRolePermissions from './OrgRolePermissions';
import { Tab, Tabs } from '../../../components/Tabs';
import OrgCareProviders from './OrgCareProviders';
import Strings from '../../../Strings';
import DefaultMessages from './DefaultMessages';
import { isSuperUser } from '../../../utils/userRoles';
import { hasPermission, PERMISSIONS } from '../../../utils/userPermissions';
import MandatoryTasks from './MandatoryTasks';
import WorkTypes from './WorkTypes';
import { PageHeader } from '../../../components/PageHeader';
import { Button } from '../../../components/PageHeader/Button';
import { HEADER_BUTTON_BLUE } from '../../../constants';
import { openModalAction } from '../../../actions/modal';
import { SAVE_ORG_TEMPLATE_MODAL_NAME } from '../../../modals/SaveOrgTemplateModal';
import DeviceMappings from '../../Admin/Config/DeviceMappings';
import DeviceInstructionVideos from './DeviceInstructionVideos';

function Configuration(props) {
  const { organizationId, organizationName, openSaveTemplateModal, isTemplate, replacePath } = props;
  const orgPrefix = organizationName ? `${organizationName}: ` : '';
  const urlParams = new URLSearchParams(window.location.search);
  const tabFromUrl = urlParams.get('tab');
  const [activeTab, setActiveTab] = React.useState(tabFromUrl || 'org');
  const canManageOrganizations = hasPermission(PERMISSIONS.ORGANIZATION_MANAGEMENT);

  const orgLabel = isTemplate ? 'Template config' : 'Organization';
  const roleLabel = isTemplate ? 'Template Roles' : 'Roles';

  React.useEffect(() => {
    if (activeTab) {
      const newUrlParams = new URLSearchParams(window.location.search);
      newUrlParams.set('tab', activeTab);
      replacePath(`${window.location.pathname}?${newUrlParams}`);
    }
  }, [activeTab]);

  const tabs = [
    <Tab label={orgLabel} key="org" className="org-permissions-tab scrollbar-right-margin">
      <OrgPermissions organizationId={organizationId} isTemplate={isTemplate}></OrgPermissions>
    </Tab>,
    <Tab label={roleLabel} key="role" className="org-role-permissions-tab scrollbar-right-margin">
      <OrgRolePermissions organizationId={organizationId} isTemplate={isTemplate}></OrgRolePermissions>
    </Tab>,
  ];
  if (!isTemplate) {
    tabs.push(
      <Tab label="Care Providers" key="care-providers" className="org-care-providers-tab scrollbar-right-margin">
        <OrgCareProviders organizationId={organizationId}></OrgCareProviders>
      </Tab>,
    );
  }
  if (!isTemplate && isSuperUser()) {
    tabs.push(
      <Tab label={Strings.workTypes} key="work-types" className="default-reminders-tab">
        <WorkTypes organizationId={organizationId} />
      </Tab>
    );
    tabs.push(
      <Tab label={Strings.mandatoryTasks} key="mandatory-tasks" className="default-reminders-tab">
        <MandatoryTasks organizationId={organizationId} />
      </Tab>
    );
  }
  if (!isTemplate && (hasPermission(PERMISSIONS.MESSAGES_DEFAULT_REMINDERS_VIEW) || isSuperUser())) {
    tabs.push(
      <Tab label={Strings.defaultReminders} key="default-reminders" className="default-reminders-tab">
        <DefaultMessages organizationId={organizationId} />
      </Tab>
    );
  }
  if (!isTemplate && isSuperUser()) {
    tabs.push(
      <Tab label={Strings.files} key="files" className="default-reminders-tab">
        <DeviceInstructionVideos organizationId={organizationId} />
      </Tab>,
    );
  }
  tabs.push(
    <Tab label="Device Mappings" key="device-mappings">
      <DeviceMappings orgId={organizationId} />
    </Tab>,
  );

  return (
    <div className="config-tab-container scrollbar-right-margin">
      <PageHeader
        left={orgPrefix + Strings.configuration}
        right={
          !isTemplate && activeTab === 'org' && canManageOrganizations ? (
            <Button
              class={HEADER_BUTTON_BLUE}
              onClick={() => openSaveTemplateModal(organizationId)}
              title={Strings.saveConfigAsTemplate}
            />
          ) : null
        }
      />
      <Tabs
        defaultIndex={tabs.findIndex(t => t.key === activeTab)}
        containerClassName="org-config-tabs scrollbar-right-margin"
        onChange={i => setActiveTab(tabs[i].key)}
      >
        {tabs}
      </Tabs>
    </div>
  );
}

const mapDispatchToProps = dispatch => ({
  openSaveTemplateModal: organizationId =>
    dispatch(
      openModalAction(SAVE_ORG_TEMPLATE_MODAL_NAME, {
        organizationId,
      }),
    ),
  replacePath: url => dispatch(replace(url)),
});

export default connect(null, mapDispatchToProps)(Configuration);
